<template>
    <v-container fluid fill-height class="home">
        <v-card class="elevation-0 transparent-card">
            <v-card-title
                class="display-3 font-weight-black white--text text-xs-center"
            >
                Welcome to the Home Page
            </v-card-title>
            <v-card-text class="headline white--text text-xs-center">
                Use the bar on the left to navigate through the platform.
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'HomePage'
};
</script>

<!-- Scoped CSS for this component -->
<style scoped>
html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden; /* Disable scrolling */
}

.home {
    background: url('../assets/upt_truck.png') no-repeat center center fixed;
    background-size: cover;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.transparent-card {
    background-color: rgba(0, 0, 0, 0.6); /* Semi-transparent background */
    padding: 20px;
    border-radius: 8px;
    width: 100%;
    max-width: 80vw; /* Control max width for responsiveness */
    box-sizing: border-box; /* Ensure padding doesn't affect the card size */
}

.home::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Dark overlay for text visibility */
}

.v-layout {
    z-index: 1; /* Ensures the layout content is above the overlay */
}
</style>
